var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['card', _vm.size, { clickable: _vm.clickable }]},[_c('CardImage',{attrs:{"card":_vm.cardData,"absolute":"","clickable":_vm.clickable,"disableScale":!_vm.cardData,"highlight":_vm.highlight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }